// extracted by mini-css-extract-plugin
module.exports =  {"labels":"_33974c2b58--labels--uaMPj"};